// @flow

import * as React from 'react';

type Props = {
  error?: string,
  children: React.Node,
};

class Form extends React.Component<Props, void> {
  render() {
    const { children, ...props } = this.props;

    return <form {...props}>{children}</form>;
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form.js